export const NAME = 'users';

export const USER_STATUSES = {
    notActivated: 0,
    active: 1,
    blocked: 2
}